import comment from './comment';
import quickNavigation from './quick_navigation.js';
import toggler from './js-toggler'
import copy from './copy';
import floating from './floating';
import search from "./search";

toggler();
quickNavigation();
comment();
copy();
floating();
search();